export const concatFullName = (fname, lname) => {
  const fullName = `${fname || ''} ${lname || ''}`
  return fullName.trim()
}
